/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { LeadRestService, SalesManagementCalculationType, UserRestService } from '@gh/builder-shared-data';
import {
  DictionaryService,
  getRouteQueryParams,
  InitViewService,
} from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import {
  LeadListItem,
  SalesManagementReportFilter,
  salesManagementReportFilterFromDto,
  salesManagementReportFilterToDto,
} from './lead.model';
import {
  isSalespersonSelectItemInactive,
  SalespersonSelectItem,
  salespersonSelectItemMapper,
  UserListItem,
} from './lead-board.model';
import { concat, map, partition, reverse, sortBy } from 'lodash';
import { FilterNames, FilterRestService } from '@gh/builder-shared';

@Injectable()
export class LeadListBusinessService implements InitViewService {
  constructor(private leadRest: LeadRestService,
              private dictionaryService: DictionaryService,
              private userRest: UserRestService,
              private filterService: FilterRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    const salesPersonId = this.geSalesPersonIdFromRoute(route);
    return {
      gridLayout: this.gridLayoutService.get('leads'),
      filter: this.filterService.get(FilterNames.leads),
      salesPersonsList: this.findAllSalesPersons(),
      salesFolderStatuses: this.dictionaryService.getDictionaryFromGlobal('SALES_FOLDER_STATUS'),
      salesPersonId,
    };
  }

  initSalesManagementReportFilterDialog(): any {
    return {
      reportFilter: this.initReportFilter(),
      salesManagementCalculationTypes: this.dictionaryService.getByEnum(SalesManagementCalculationType),
    };
  }

  findAllAsDataSource(filter?: any): SlicedDataSource<LeadListItem> {
    return this.leadRest.findAllAsDataSource(filter);
  }

  initReportFilter(): Observable<SalesManagementReportFilter> {
    return this.leadRest.initReportFilter().pipe(map$(salesManagementReportFilterFromDto));
  }

  updateReportFilter(reportFilter: SalesManagementReportFilter): Observable<void> {
    return this.leadRest.updateReportFilter(salesManagementReportFilterToDto(reportFilter));
  }
  findAllSalesPersons(): Observable<SalespersonSelectItem[]> {
    return this.userRest.findAllSalesPersons(true).pipe(
      map$((userList: UserListItem[]) =>
             concat(
               [],
               ...reverse(
                 partition(
                   sortBy(
                     map(userList, salespersonSelectItemMapper),
                     'name',
                   ),
                   isSalespersonSelectItemInactive)))));
  }

  private geSalesPersonIdFromRoute(route: ActivatedRouteSnapshot): string {
    const params = getRouteQueryParams(route);
    if (params && params.filter) {
      const filter = JSON.parse(params.filter);
      if (filter && filter.salesPersonId) {
        return filter.salesPersonId;
      }
    }
    return '';
  }
}
